<template>
  <div>
    <a-card class="card">
      <SearchView
        :renderItem="searchSchema"
        :isExpandShowOrNot="false"
        :initialValues="searchForm"
        @fetchSearch="handleSearch"
      ></SearchView>
    </a-card>

    <a-card>
      <div class="text-right">
        <a-button
          type="primary"
          icon="plus"
          class="add-btn"
          @click="uploadVisible = true"
        >
          批量上传
        </a-button>
      </div>
      <TableView
        :data="tableData"
        :columns="tableColumns"
        :pagination="pageData"
        :loading="tableLoading"
        :scroll="{ x: 800 }"
        @handlePagination="handleClickPage"
      >
        <template v-slot:status="{ tableRow }">
          {{ tableRow.status === 1 ? '失效' : '生效' }}
        </template>

        <template v-slot:action="{ tableRow }">
          <div>
            <a-button type="link" size="small" @click="handleEdit(tableRow)">
              编辑
            </a-button>
            <a-divider type="vertical" />
            <a-popconfirm
              title="此操作将删除该条信息, 是否继续?"
              @confirm="handleDeleteConfirm(tableRow)"
            >
              <a-icon slot="icon" type="question-circle-o" class="icon-color" />
              <a-button type="link" size="small">
                删除
              </a-button>
            </a-popconfirm>
          </div>
        </template>
      </TableView>
    </a-card>

    <a-modal :width="500" v-model="visible" title="编辑" :maskClosable="false">
      <a-form-model
        ref="modalForm"
        :model="modalForm"
        :rules="modalFormRules"
        :labelCol="{ span: 5 }"
        :wrapperCol="{ span: 19 }"
      >
        <a-form-model-item label="客户编号" prop="customerCode">
          <a-input v-model="modalForm.customerCode" />
        </a-form-model-item>
        <a-form-model-item label="客户名称" prop="customerName">
          <a-input v-model="modalForm.customerName" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="status">
          <a-select v-model="modalForm.status">
            <a-select-option :value="0">
              生效
            </a-select-option>
            <a-select-option :value="1">
              失效
            </a-select-option>
          </a-select>
        </a-form-model-item>
      </a-form-model>
      <template slot="footer">
        <a-button @click="handleCancel">取消</a-button>
        <a-button type="primary" @click="handleOk">确定</a-button>
      </template>
    </a-modal>

    <a-modal
      :width="500"
      v-model="uploadVisible"
      title="批量上传"
      :maskClosable="false"
    >
      <a-row :gutter="[0, 20]">
        <a-col :span="4">
          上传附件：
        </a-col>
        <a-col :span="19">
          <p
            style="width: 100%; overflow: hidden; text-overflow: ellipsis; white-space: nowrap"
          >
            <a-upload :showUploadList="false" :before-upload="beforeUpload">
              <a-button type="primary" size="small">
                <a-icon type="upload" />
                选择文件
              </a-button>
            </a-upload>
            <span style="margin-left: 10px;">{{ filename }}</span>
          </p>
        </a-col>
      </a-row>
      <a-row :gutter="[0, 20]">
        <a-col :span="4">
          模板下载：
        </a-col>
        <a-col :span="19">
          <a-button type="link" size="small" @click="_downloadTemplate">
            点击下载
          </a-button>
        </a-col>
      </a-row>
      <template slot="footer">
        <a-button @click="handleUploadCancel">取消</a-button>
        <a-button type="primary" @click="handleUploadOk">确定</a-button>
      </template>
    </a-modal>
  </div>
</template>

<script>
import { SearchView, TableView } from 'lxfintech-fe'
import mixin from './mixin'
import { getTableData, remove, update, upload, downloadTemplate } from './api'

export default {
  mixins: [mixin],
  data() {
    return {
      searchCardLoading: true,
      tableLoading: true,
      visible: false,
      modalForm: {
        customerCode: '',
        customerName: '',
        status: '',
        id: '',
      },
      modalFormRules: {
        customerCode: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        customerName: [
          { required: true, message: '请输入内容', trigger: 'blur' },
        ],
        status: [{ required: true, message: '请选择内容', trigger: 'change' }],
      },
      uploadVisible: false,
      file: null,
    }
  },
  components: {
    SearchView,
    TableView,
  },
  mounted() {
    this._getTableData()
  },
  computed: {
    filename() {
      return this.file?.name
    },
  },
  methods: {
    // 获取表格数据
    _getTableData() {
      this.tableLoading = true
      const { current, pageSize } = this.pageData

      const formData = {
        ...this.searchForm,
        size: pageSize,
        current,
      }

      getTableData(formData).then(({ data: { total, records } }) => {
        this.pageData.total = total
        this.tableData = records
        this.tableLoading = false
      })
    },
    // 点击编辑
    handleEdit(row) {
      this.visible = true
      this.$nextTick(() => {
        Object.keys(this.modalForm).forEach(key => {
          this.modalForm[key] = row[key]
        })
      })
    },
    // 删除
    handleDeleteConfirm({ id }) {
      remove(id).then(({ message }) => {
        this.$notification.success({
          message: '提示',
          description: message,
        })
        this._getTableData()
      })
    },
    handleCancel() {
      this.$refs.modalForm.resetFields()
      this.modalForm.id = ''
      this.visible = false
    },
    async handleOk() {
      const valid = await this.$refs.modalForm.validate()
      if (valid) {
        await update({ ...this.modalForm })
        this.$message.success('修改成功')
        this.handleCancel()
        this._getTableData()
      }
    },
    beforeUpload(file) {
      this.file = file
      return false
    },
    handleUploadCancel() {
      this.file = null
      this.uploadVisible = false
    },
    async handleUploadOk() {
      if (!this.file) {
        this.$message.warning('请选择文件')
        return
      }
      await upload({ file: [this.file] })
      this.$message.success('上传成功')
      this.handleUploadCancel()
      this._getTableData()
    },
    async _downloadTemplate() {
      await downloadTemplate()
    },
  },
}
</script>
